import { SVGFC } from '@repo/toolkit/types'

const BellIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.42846 3.6066C10.2281 3.20676 11.1081 2.99917 12 3C15.3129 3 18 5.8224 18 9.3045V9.939C17.9989 10.6964 18.2124 11.4382 18.6151 12.0765L19.5999 13.6281C20.4986 15.0456 19.8124 16.9725 18.2488 17.4207C14.1634 18.5934 9.83655 18.5934 5.75115 17.4207C4.18761 16.9725 3.50139 15.0456 4.40005 13.629L5.38493 12.0765C5.78764 11.4382 6.00111 10.6964 6.00004 9.939V9.3045C6.00004 8.3379 6.20715 7.4217 6.57782 6.6027M8.00003 18.3C8.58225 19.8732 10.1529 21 12 21C12.2178 21 12.4311 20.9847 12.64 20.955M16 18.3C15.7593 18.9425 15.361 19.5124 14.8426 19.956"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default BellIcon
